import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
    { id: "sobre", label: "Sobre" },
    { id: "features", label: "Recursos" },
    { id: "regras", label: "Regras" },
    { id: "staff", label: "Staff" },
    { id: "conectar", label: "Conectar" },
    { id: "galeria", label: "Galeria" },
    { id: "faq", label: "FAQ" },
];

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "backdrop-blur-xl bg-black/70 border-b border-white/10"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 flex items-center justify-between h-20">
                <a
                    href="#top"
                    data-testid="header-logo"
                    className="flex items-center gap-3"
                >
                    <span className="font-heading text-3xl md:text-4xl text-neon-yellow leading-none tracking-tight">
                        FORZA
                    </span>
                    <span className="hidden md:inline font-mono text-[10px] uppercase tracking-[0.3em] text-white/60 border-l border-white/20 pl-3">
                        Pilots /// FIVEM
                    </span>
                </a>

                <nav className="hidden lg:flex items-center gap-8">
                    {NAV.map((n) => (
                        <a
                            key={n.id}
                            href={`#${n.id}`}
                            data-testid={`nav-link-${n.id}`}
                            className="font-mono text-xs uppercase tracking-[0.2em] text-white/70 hover:text-neon-yellow transition-colors"
                        >
                            {n.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <a
                        href="#conectar"
                        data-testid="header-connect-cta"
                        className="hidden md:inline-flex bg-neon-yellow text-black font-heading text-lg uppercase px-5 py-2.5 hover:bg-white transition-colors"
                    >
                        Jogar Agora
                    </a>
                    <button
                        data-testid="mobile-menu-toggle"
                        onClick={() => setOpen(!open)}
                        className="lg:hidden text-white p-2 border border-white/20"
                        aria-label="menu"
                    >
                        {open ? <X size={20} /> : <Menu size={20} />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="lg:hidden bg-black border-t border-white/10">
                    <div className="px-6 py-6 flex flex-col gap-4">
                        {NAV.map((n) => (
                            <a
                                key={n.id}
                                href={`#${n.id}`}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-${n.id}`}
                                className="font-mono text-sm uppercase tracking-[0.2em] text-white/80 hover:text-neon-yellow"
                            >
                                / {n.label}
                            </a>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
}
